import { useEffect, useState } from 'react'
import { api, type ChainResponse } from '../api'

export function useChain(params?: Record<string, string>) {
  const [data, setData] = useState<ChainResponse | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const run = async (p?: Record<string, string>) => {
    setLoading(true)
    setError(null)
    try {
      const result = await api.chain(p || params)
      setData(result)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Chain fetch failed')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    run()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(params)])

  return { data, loading, error, run }
}
